import React, { useContext, useEffect, useState } from 'react'
import ModalCargando from '../utilsComponentes/ModalCargando';
import MsgUtils from '../Tools/MsgUtils';
import ReporteHelados from './ReporteHelados';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function AlmacenRegional() {
    const {loading,setLoading} = useContext(ContextGloball);
    const [regional, setRegional] = useState('991');
    const [listaAlmacen, setListaAlmacen] = useState([]);
    const [listaTipoA, setListaTipoA] = useState([]);
    const [diaProyectado, setDiaProyectado] = useState([]);
    const [tipoRep,setTipoRep] = useState('P');
    const [banderaCambio,setBanderaCambio] = useState(false);
    const [actualizar,setActualizar] = useState(false);
    const eventoCLick = () => {
        if(tipoRep=='P'){
            getInformacion();
        }else{
            setActualizar(!actualizar);
        }
    }
    function getSumaValorLo(lista,val) {
        if (lista.length !== 0) {
            var suma = lista.filter(item => item.ID_PRODUCTO == val).map(j => j.STOCK);
            var aux = suma.reduce((a, b) => a + b, 0);
            var num = aux;
            if (val == 102) {
                num = aux.toFixed(2)
            }
            return num
        } else {
            return 0
        }
    }
    function getProyeccion(lista) {
        fetch(`${server}/reporte/getProyeccion`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {   
                    var resultado = data.ok;                 
                    var sumtP=getSumaValorLo(lista,100);
                    var sumtH=parseFloat(getSumaValorLo(lista,102));
                    var sumtRP=getSumaValorLo(lista,101)
                    var lengt = data.ok.filter((item)=>item.ID_PRODUCTO==-3)
                    for (var i=0;i<lengt.length;i++){
                        resultado[i].transformadoh=resultado[i].TOTAL+(resultado[i+lengt.length].TOTAL/40)*3;
                        resultado[i].transformadop=resultado[i].TOTAL+(resultado[i+lengt.length].TOTAL/40);
                        resultado[i].saldoh = sumtH-resultado[i].transformadoh;
                        resultado[i].saldop = sumtP-resultado[i].transformadop;
                        resultado[i].saldorp = sumtRP-8;
                        sumtH=parseFloat(resultado[i].saldoh).toFixed(2);
                        sumtP=parseFloat(resultado[i].saldop).toFixed(2);
                        sumtRP=resultado[i].saldorp;
                    }
                    setDiaProyectado(resultado);
                } else {
                    MsgUtils.msgError(data.message);
                }
                setLoading(false);
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function  getInformacionHelado(){
        setLoading(true);
        fetch(`${server}/reporte/getReportePlantaHelados`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'ID_SUCURSAL': 14
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.ok)
                setLoading(false);
                if (data.ok) {
                    setListaAlmacen(data.ok);
                    var almacen = data.ok.map(item => item.NOMBRE_ALMACEN);
                    var aux = new Set(almacen);
                    setListaTipoA([...aux]);
                    setBanderaCambio(true);
                } else {
                    setLoading(false);
                    MsgUtils.msgError(data.message);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function getInformacion() {
        setLoading(true);
        fetch(`${server}/reporte/getReportePlanta`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, 'ID_SUCURSAL': 14
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    console.log(data.ok)
                    setListaAlmacen(data.ok);
                    var almacen = data.ok.map(item => item.NOMBRE_ALMACEN);
                    var aux = new Set(almacen);
                    setListaTipoA([...aux]);
                    getProyeccion(data.ok);
                } else {
                    setLoading(false);
                    MsgUtils.msgError(data.message);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function cambiarTipo(valor){
        setListaTipoA([])
        if(valor=='H'){
            setTipoRep(valor);
            getInformacionHelado();
        }else{
            setBanderaCambio(false);
            setTipoRep(valor);
            getInformacion();
        }
    }
    function getConvHarinado(valor){
        return valor
    }
    function getSumaValor(val) {
        if (listaAlmacen.length !== 0) {
            var suma = listaAlmacen.filter(item => item.ID_PRODUCTO == val).map(j => j.STOCK);
            var aux = suma.reduce((a, b) => a + b, 0);
            var num = aux;
            if (val == 102) {
                num = aux.toFixed(2)
            }
            return num
        } else {
            return 0
        }
    }
    function getDia(fecha){
        var diasSemana= ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado']
        var dat=new Date(fecha);
        return diasSemana[dat.getDay()]
    }
    useEffect(() => {
        if (listaAlmacen.length == 0) {
            getInformacion();
        }
    }, [])
    return (
        <div className=''>
            <div className='container-fluid bg-dark bg-gradient'>
                <div className='btn-group btn-group-sm py-1'>
                    <div className="input-group input-group-sm my-auto d-none" >
                        <span className="input-group-text bg-secondary bg-gradient text-light" >Regional</span>
                        <select className=" form-select text-center "
                            value={regional} onChange={setRegional}
                        >
                            <option value='990'>CBBA</option>
                            <option value='991'>SCRZ</option>
                        </select>
                    </div>
                    <button className='btn btn-success btn-sm mx-2' onClick={() => eventoCLick()}>
                        Actualizar
                    </button>
                    <button className={`btn ${tipoRep=='P'?'selected ':'btn-secondary'} btn-sm`} onClick={()=>cambiarTipo('P')}>
                        Harinado y Proceso
                    </button>
                    <button className={`btn ${tipoRep=='H'?'selected ':'btn-secondary'} btn-sm`} onClick={()=>cambiarTipo('H')}>
                        Helados
                    </button>
                </div>
            </div>
            {tipoRep=='P'&&<div className='container-fluid py-2'>
                <div className='card mb-2' style={{ minHeight: '215px' }}>
                    <div className='card-header text-center'>
                        {'SANTA CRUZ'}
                    </div>
                    <div className='card-body'>
                        <table className="table table-stripet">
                            <thead>
                                <tr>
                                    <th scope="col">Almacen</th>
                                    <th scope="col">Procesos</th>
                                    <th scope="col">ReProcesos</th>
                                    <th scope="col">Harinado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaTipoA.map((item, index) => {
                                    var aux = listaAlmacen.filter((dato) => dato.NOMBRE_ALMACEN == item).sort((a, b) => a.ID_PRODUCTO < b.ID_PRODUCTO);
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{aux[0].NOMBRE_ALMACEN!=undefined?aux[0].NOMBRE_ALMACEN:'?'}</th>
                                            <td>{aux[0].STOCK + ' ' + aux[0].SIMBOLO}</td>
                                            <td>{aux[1].STOCK+ ' ' + aux[1].SIMBOLO}</td>
                                            <td>{aux[2].STOCK.toFixed(2) + ' '+ aux[2].SIMBOLO}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th> Total: </th>
                                    <td>{getSumaValor(100)}</td>
                                    <td>{getSumaValor(101)}</td>
                                    <td>{getSumaValor(102)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div className='row row-cols g-1'>
                    <div className='col' >
                        <div className='card'>
                            <div className='carg-header text-center fw-bold bg-gradient bg-dark text-light'>
                                Proyeccion Uso Procesos
                            </div>
                            <div className='card-body'>
                                <table className="table table-stripet">
                                    <thead>
                                        <tr>
                                            <th scope="col">DIA</th>
                                            <th scope="col">Uso</th>
                                            <th scope="col">saldo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {diaProyectado.map((item, index) => {
                                            if (item.ID_PRODUCTO==-3)
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{getDia(item.FECHA)}</th>
                                                        <td >{item.transformadop}</td>
                                                        <td className={`${parseFloat(item.saldop)<=0?'bg-danger text-light':''}`}>{item.saldop.toFixed(2)}</td>
                                                    </tr>
                                                )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='col' >
                        <div className='card'>
                            <div className='carg-header text-center fw-bold bg-gradient bg-dark text-light'>
                                Proyeccion Uso Re-Procesos
                            </div>
                            <div className='card-body'>
                                <table className="table table-stripet">
                                    <thead>
                                        <tr>
                                            <th scope="col">DIA</th>
                                            <th scope="col">Uso</th>
                                            <th scope="col">saldo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {diaProyectado.map((item, index) => {
                                            if (item.ID_PRODUCTO==-3)
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{getDia(item.FECHA)}</th>
                                                        <td >8</td>
                                                        <td className={`${parseFloat(item.saldorp)<=0?'bg-danger text-light':''}`}>{item.saldorp}</td>
                                                    </tr>
                                                )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='col' >
                        <div className='card'>
                            <div className='carg-header text-center fw-bold bg-gradient bg-dark text-light'>
                                Proyeccion Uso Harinado
                            </div>
                            <div className='card-body'>
                                <table className="table table-stripet">
                                    <thead>
                                        <tr>
                                            <th scope="col">Dia</th>
                                            <th scope="col">Uso</th>
                                            <th scope="col">saldo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {diaProyectado.map((item, index) => {
                                            if (item.ID_PRODUCTO==-3)
                                                return (
                                                    <tr key={index}>
                                                        <th scope="row">{getDia(item.FECHA)}</th>
                                                        <td>{item.transformadoh}</td>
                                                        <td className={`${item.saldoh<0?'bg-danger text-light':''}`}>{item.saldoh.toFixed(2)}</td>
                                                    </tr>
                                                )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            {tipoRep=='H'&& banderaCambio&&
            <ReporteHelados loading={loading} setLoading={setLoading} regional={regional} actualizar={actualizar}/>
            }
        </div>
    )
}

export default AlmacenRegional